import {Box, Heading} from '@chakra-ui/react'
import React, {useMemo} from 'react'
import useSitePreference from '../../../../hooks/use-site-preference'
import {headingStyles, brandContainerStyles} from './index.style'
import PropTypes from 'prop-types'

const BrandHeader = ({category, selectedRefinements}) => {
    const isBrandSubCat =
        category.parentCategoryId && category.parentCategoryId.toLowerCase() === 'brands'
    const {data} = useSitePreference('targetedRefinementsForH1SEO')
    const targetedRefinementsForH1SEO = data?.targetedRefinementsForH1SEO || []
    const productLandingH1ForSEO = useMemo(() => {
        let h1 = category?.c_categoryLandingH1ForSEO || category.name
        if (
            Object.keys(selectedRefinements).length < 2 ||
            !isBrandSubCat ||
            !targetedRefinementsForH1SEO.length
        ) {
            return h1
        }

        const intersection = targetedRefinementsForH1SEO.filter(function (n) {
            return selectedRefinements[`c_${n}`]
        })

        if (
            intersection.length === 1 &&
            selectedRefinements[`c_${intersection[0]}`]?.split('|').length === 1
        ) {
            h1 = selectedRefinements[`c_${intersection[0]}`] + ' ' + h1
        }

        return h1
    }, [category, selectedRefinements, targetedRefinementsForH1SEO])
    if (!isBrandSubCat) {
        return (
            <Heading as="h1" sx={headingStyles}>
                {productLandingH1ForSEO}
            </Heading>
        )
    }

    return (
        <Box sx={brandContainerStyles} className="brand-main-container" bis_skin_checked="1">
            <Box className="brand-logo-container" bis_skin_checked="1">
                <img
                    src={category.c_brandsImage}
                    alt={productLandingH1ForSEO}
                    title={productLandingH1ForSEO}
                />
            </Box>
            <Box className="plp-top-heading" bis_skin_checked="1">
                <h1>{productLandingH1ForSEO}</h1>
            </Box>

            {category.description && (
                <Box className="plp-top-header-content plpReadMore" bis_skin_checked="1">
                    {category.description}
                </Box>
            )}
        </Box>
    )
}

BrandHeader.propTypes = {
    category: PropTypes.object,
    selectedRefinements: PropTypes.object
}

export default BrandHeader
